import type {CancellablePromise} from '@yourcoach/async-utils';

export function handleInvalidJWT(
  delayPromisesMap: Record<string, CancellablePromise<unknown>>,
  apiRequestFn: any,
) {
  apiRequestFn.__deleteSession();

  Object.keys(delayPromisesMap).forEach(key => {
    delayPromisesMap[key]?.cancel?.();
  });
}
